const errorCodeDictionary = {
  errorCodes: {
    fieldRequired: "Please fill in this field.",
    notUnique: "Value is not unique.",
    unknownExecutionError: "Unknown error."
  }
};
export {
  errorCodeDictionary
};
//# sourceMappingURL=errorCodeDictionary.js.map
